import { api } from "api/api";
import { CONTEXT_TYPES } from "./get-book-appointment-dashboard-items";

export type AvailableDaysParams = {
    doctorId?: string;
    typeId?: string;
    month: string; // YYYY-MM
    context: CONTEXT_TYPES;
    contextId: string;
}

export default async function getAvailableDays({ context, contextId, typeId, doctorId, month }: AvailableDaysParams) {
    const url = 'api/public/book/appointment/online/available/days';

    const response = await api.get(url, {
        params: {
            typeId,
            doctorId,
            month,
            context,
            contextId,
        }
    });
    return response.data.data as string[];
}
